//All pages
(function ($) {
  var windowObj = $(window); //window cached in var for performance
  var sapiaBody = $('body'); //body cached in var for performance
  var documentObj = $(document);
  /***
  ********
  ****
  Smooth Scrolling Function (redunant due to hashHandler()?)
  ****
  ********
  ***/
  function smoothScrolling() {
    $('a[href*=\\#]:not([href=\\#],[href="\\#0"],[data-toggle="tab"],.no-smooth-scroll)').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

        let offset = (window.innerWidth < 992 ? 30 : 50);
        offset += document.querySelector('.site-header__navbar').offsetHeight;
        offset += (document.body.classList.contains('admin-bar') ? document.getElementById('wpadminbar').offsetHeight : 0);

        if (target.length) {
          $('html,body').animate({
            scrollTop: target.offset().top - offset
          }, 1000);
          return false;
        }
      }
    });
  }
  smoothScrolling();
  /***
  ********
  ****
  Return to top anchor
  ****
  ********
  ***/
  function returnTop() {
    var returnTop = $('.return-to-top');
    windowObj.scroll(function() {
      if ($(this).scrollTop() >= 50) {
        returnTop.fadeIn(200);
      } else {
        returnTop.fadeOut(200);
      }
    });
    returnTop.on('click', function(){
      $('body,html').animate({
        scrollTop : 0
      }, 500);
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  sapia Navbar Functionality
  ****
  ********
  ***/
  function sapiaNavbar() {
    var siteHeader = $('.site-header');
    //shrink navbar on scroll
    windowObj.scroll(function() {
      if (documentObj.scrollTop() > 20) {
        siteHeader.addClass('site-header--shrink');
      }
      else {
        if (!$('.navbar-collapse').hasClass('show')) {
          //if its a mobile menu showing, don't remove class because it needs background colour applied by shrink class
          siteHeader.removeClass('site-header--shrink');
        }
      }
    });
    $('.site-header__navbar-toggler').on('click', function(){
      var toggle = $(this);
      if (!toggle.hasClass('site-header__navbar-toggler--open')) {
        toggle.addClass('site-header__navbar-toggler--open');
      }
      else {
        toggle.removeClass('site-header__navbar-toggler--open');
      }
      /*//add shrink class to ensure there's a bg color
      siteHeader.addClass('site-header--shrink');*/
    });
    //add class to standard dropdowns to differentiate between mega menus and standard (one column) dropdowns, if someone knows how to add this to the navwalker so we don't have to do this with JS, please be my guest!
    $('.dropdown-menu').not(':has(.sub-menu)').addClass('standard-dropdown-menu');
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  GDPR Consent Bar Functionality
  ****
  ********
  ***/
  function gdprConsent() {
    var gdprConsentBar = $('.gdpr-consent');
    windowObj.scroll(function() {
      if (documentObj.scrollTop() > 70) {
        gdprConsentBar.addClass('gdpr-hidden animated');
      }
      else {
        gdprConsentBar.removeClass('gdpr-hidden animated');
      }
    });

    $('.gdpr-give-consent').click(function(event){
      event.preventDefault();
      Cookies.remove('sapia_gdpr_consent_undecided');
      Cookies.set('sapia_gdpr_consent', 1, { expires: 365, path: '/' });
      gdprConsentBar.hide();
      //$('.gdpr-consent__accepted-notice').addClass('show-accepted-message animated');
    });

    $('.gdpr-close').click(function(event){
      gdprConsentBar.addClass('gdpr-hidden animated');
      setTimeout(function() { gdprConsentBar.remove(); }, 2000);
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  sapia Accordion Functionality
  ****
  ********
  ***/
  function sapiaAccordions() {
    $('.accordion__title').each(function() {
      var accordion = $(this), state = false, accordionContent = accordion.next('.accordion__content').hide().css('height','auto').slideUp();
      accordion.click(function() {
        state = !state;
        accordionContent.slideToggle(state);
        accordion.parent().toggleClass('accordion-open',state);
      });
    });
  }
  sapiaAccordions();
  /***
  ********
  ****
  Animated Sections
  ****
  ********
  ***/
  function animateSections() {
    $('section, .watch-in-view').each(function() {
      var vBlock = new Waypoint.Inview({
        element: this,
        enter: function(direction) {
          $(this.element).addClass('in-view');
        },
        offset: 50
      });
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Flickity Carousel
  ****
  ********
  ***/
  function flickityCarousel() {
    var carousel = $('.carousel__carousel');
    if (carousel != null) {
      var $carousel = $('.carousel__carousel').flickity({
        // options
        cellAlign: 'center',
        pageDots: true,
        wrapAround: true,
        adaptiveHeight: true
      });
    }
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Progress Bars
  ****
  ********
  ***/
  function progressBars() {
    $('.sapia-progress-bar').each(function(i,obj) {
      var vBlock = new Waypoint.Inview({
        element: this,
        enter: function(direction) {
          let percent = 0
          let target_percentage = $(this.element).data('target-percentage');
          let percentage_label = $('.sapia-progress-bar__text__percent', this.element);
          let bar_inner = $('.sapia-progress-bar__bar__bar-inner', this.element);
          let timer = setInterval(function() {
            percent += 1
            percentage_label.text(`${percent} %`);
            bar_inner.css('width', `${percent}%`);
            if(percent >= target_percentage) {
              clearInterval(timer);
            }
          }, 20);
          this.destroy();
        },
        offset: 50
      });
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Statistic Circles
  ****
  ********
  ***/
  function statisticCircles() {
    $('.statistic-columns__statistic').each(function(i,obj) {
      var vBlock = new Waypoint.Inview({
        element: this,
        enter: function(direction) {
          let el = $(this.element);
          let target_value = parseFloat(el.data('target-value'));
          let max_value = parseFloat(el.data('max-value'));;

          if ($(this.element).hasClass('statistic-columns__statistic--light')) {
            var line_colour = '#9ACEDC';
          }
          else {
            var line_colour = '#245069';
          }

          $(this.element).circleProgress({
            value: target_value / max_value,
            size: 200,
            fill: line_colour,
            startAngle: -(Math.PI / 2),
            emptyFill: 'rgba(0, 0, 0, .05)',
            thickness: 10,
            lineCap: 'round'
          }).on('circle-animation-progress', function(event, progress, stepValue) {
            let el = $(this);
            let precision = parseFloat(el.data('precision'));
            precision = Math.pow(10, precision);
            display_value = (Math.round(stepValue * parseFloat(el.data('max-value')) * precision)) / precision;

            el.find('strong').html(
              '<i class="statistic-columns__statistic__prepend">' + el.data('prepend') + '</i>' +
              '<i class="statistic-columns__statistic__value">' + display_value + '</i>'  +
              '<i class="statistic-columns__statistic__append">' + el.data('append') + '</i>'
            );
          });
          this.destroy();
        },
        offset: 50
      });
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Flickity Carousel
  ****
  ********
  ***/
  function testimonialCarousel() {
    var carousel = $('.testimonial-carousel__carousel');
    if (carousel != null) {
      var $carousel = $('.testimonial-carousel__carousel').flickity({
        // options
        cellAlign: 'center',
        pageDots: true,
        wrapAround: true,
        adaptiveHeight: true
      });
    }
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Flickity Carousel
  ****
  ********
  ***/
  function partnersCarousel() {
    var carousel = $('.partner-logos__carousel');
    if (carousel != null) {
      var $carousel = $('.partner-logos__carousel').flickity({
        // options
        cellAlign: 'center',
        pageDots: false,
        wrapAround: true,
        adaptiveHeight: true
      });
    }
  }
  /***
  ********
  ****
  Secondary Nav Scroll
  ****
  ********
  ***/
  function secondaryNavScroll() {
    //get query var function from https://stackoverflow.com/questions/19491336/how-to-get-url-parameter-using-jquery-or-plain-javascript
    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };
    //scroll if query var is true
    if (getUrlParameter('scroll')) {
      var secondary_nav = $('.secondary-navigation__nav-item');
      if (secondary_nav.length) {
        next_element = $('body').find('section').nextAll("section:not(.hero),section:not(.breadcrumbs),section:not(.secondary_navigation)").first();
        $('html, body').animate({
          scrollTop: next_element.offset().top
        }, 1000);
      }
    }
  }
  /******* Executed in document ready at end of file *******/
  function partnersCarousel() {
    var carousel = $('.partner-logos__carousel');
    if (carousel != null) {
      var $carousel = $('.partner-logos__carousel').flickity({
        // options
        cellAlign: 'center',
        pageDots: false,
        wrapAround: true,
        adaptiveHeight: true
      });
    }
  }
  /***
  ********
  ****
  Demo Widget
  ****
  ********
  ***/
  /*$('.demo-widget').on('mouseover', function(){
    $(this).toggleClass('demo-widget--active');
  });*/
  //mediabox video modals
  MediaBox('.mediabox');
  //match height of grouped elements
  $('.matchHeight').matchHeight();
  /***
  ********
  ****
  Functions which require document to be ready
  ****
  ********
  ***/
  $(function() {
    sapiaNavbar();
    returnTop();
    gdprConsent();
    animateSections();
    flickityCarousel();
    progressBars();
    statisticCircles();
    testimonialCarousel();
    partnersCarousel();
    secondaryNavScroll();
  });
})(jQuery); // Fully reference jQuery after this point.
